import React, { useEffect, useState } from "react";
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from "../../../components/DataTable/Interfaces";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { UserProps } from '../../../types/IdProps';


const User_tab_Following: React.FC<UserProps> = ({ userId }) => {
    const [data, setData] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [userId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemFollowers/ByUser/' + userId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'itemId', visible: false },
        { title: 'Item', dataProp: 'item', dataType: 'item', sort: 'asc' }
    ];

    return (
        <>
            {data && (
                <DataTable
                    name='dtItemFollowers'
                    colInfos={colInfos}
                    tableData={data}
                />
            )}
        </>
    );
}
export default User_tab_Following;